<template>
  <div class="navigation">
    <div
      v-for="menu in availableMenus"
      :key="menu.name"
      class="navigation__item"
    >
      <v-hover v-slot="{ hover }">
        <router-link
          v-slot="{isActive}"
          :to="menu.link"
        >
          <a
            class="navigation__item__link"
            :class="{'navigation__item__link_active': isActive }"
            @click.prevent="setActiveMenuId(menu)"
          >
            <v-icon
              :color="isActive || hover ? 'primary' : 'white'"
              large
            >
              {{ menu.icon }}
            </v-icon>
            <transition name="fade">
              <span
                v-if="sidebarIsOpen"
                class="navigation__item__text"
              >{{ menu.name }}</span>
            </transition>
          </a>
        </router-link>
      </v-hover>
      <div
        v-if="menu.deep && menu.id === activeMenuId && sidebarIsOpen"
        class="navigation__item__deep"
      >
        <router-link
          v-for="deep in menu.deep"
          :key="deep.name"
          :to="deep.link"
          class="navigation__item__deep__link"
          active-class="navigation__item__deep__link_active"
        >
          {{ deep.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import interfaces from '@/router/interfaces';

let id = 0;
export default {
  name: 'AppNavigation',

  props: {
    sidebarIsOpen: {
      type: Boolean,
    },
  },

  data: (vm) => ({
    activeMenuId: null,
    menus: [
      {
        name: vm.$t('navigation.desktop'),
        link: '/desktop',
        icon: 'mdi-view-dashboard-outline',
      },
      {
        id: id++, // eslint-disable-line no-plusplus
        name: vm.$t('navigation.pages'),
        link: '/content',
        icon: 'mdi-message-image',
        deep: [
          {
            name: vm.$t('navigation.pages_news'),
            link: '/content/list/news',
          },
          {
            name: vm.$t('navigation.pages_special'),
            link: '/content/list/special-offer',
          },
          {
            name: vm.$t('navigation.pages_top'),
            link: '/content/list/top',
          },
          {
            name: vm.$t('navigation.pages_help'),
            link: '/content/help',
          },
        ],
      },
      {
        name: vm.$t('navigation.users'),
        link: '/users',
        icon: 'mdi-account-multiple',
      },
      {
        name: vm.$t('navigation.dealers'),
        link: '/dealers',
        icon: 'mdi-truck-outline',
      },
      {
        id: id++, // eslint-disable-line no-plusplus
        name: vm.$t('navigation.emails'),
        link: '/emails',
        icon: 'mdi-email-outline',
        deep: [
          {
            name: vm.$t('navigation.email_list'),
            link: '/emails/list',
          },
          {
            name: vm.$t('navigation.templates'),
            link: '/emails/templates',
          },
        ],
      },
      {
        name: vm.$t('navigation.orders'),
        link: '/orders',
        icon: 'mdi-format-list-bulleted',
      },
      {
        name: vm.$t('navigation.requests'),
        link: '/requests',
        icon: 'mdi-clipboard-edit-outline',
      },
      {
        name: vm.$t('navigation.complaints'),
        link: '/complaints',
        icon: 'mdi-chat-alert',
      },
      {
        id: id++, // eslint-disable-line no-plusplus
        name: vm.$t('navigation.reports'),
        link: '/reports',
        icon: 'mdi-finance',
        deep: [
          {
            name: vm.$t('navigation.complaints_report'),
            link: '/reports/complaints',
          },
          {
            name: vm.$t('navigation.settlement_report'),
            link: '/reports/settlement',
          },
        ],
      },
      {
        name: vm.$t('navigation.logs'),
        link: '/logs',
        icon: 'mdi-cog-outline',
      },
      {
        name: vm.$t('navigation.queues_list'),
        link: '/queues-list',
        icon: 'mdi-format-line-spacing',
      },
      {
        name: vm.$t('navigation.versions'),
        link: '/versions',
        icon: 'mdi-application',
      },
    ],
  }),

  computed: {
    userInterfaces() {
      return { ...this.$store.getters };
    },

    availableMenus() {
      const getAvailability = (menu) => {
        const path = menu.link.slice(1);
        return !interfaces[path] || interfaces[path](this.userInterfaces);
      };
      const availableMenus = this.menus
        .map((menu) => ({ ...menu, deep: menu.deep && menu.deep.filter(getAvailability) }))
        .filter((menu) => (menu.deep ? menu.deep.length : getAvailability(menu)));
      return availableMenus;
    },
  },

  methods: {
    setActiveMenuId(menu) {
      if (!menu.deep) {
        if (this.$route.path !== menu.link) {
          this.$router.push(menu.link);
        }
      } else if (this.sidebarIsOpen) {
        this.activeMenuId = this.activeMenuId === menu.id ? null : menu.id;
      } else {
        this.$emit('open');
        this.activeMenuId = menu.id;
      }
    },
  },
};
</script>

<style lang="scss">
.navigation__item__text {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
